export default "__VITE_ASSET__CtXJtNwi__"